'use client';

import { useDispatch, useSelector } from 'react-redux';
import { userState } from '../userSlice/userSlice';
import { RootState } from '../store';
import {
  customerState,
  customerTypes,
  setCustomer,
  unsetCustomer,
} from './customerSlice';
import { useLazyGetUserQuery } from '@api/api';
import { useEffect } from 'react';
import { setCookie } from 'cookies-next';

export function useCustomerSetter() {
  const dispatch = useDispatch();
  const cookies = ['Id', 'Type', 'Name'];
  return (payload: customerState) => {
    const expire = new Date();
    expire.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 14);
    cookies.forEach((cookie: string) => {
      setCookie('customer' + cookie, payload[cookie.toLowerCase() as keyof customerState], {
        expires: expire,
      });
    });
    dispatch(setCustomer(payload));
  };
}

export function useCustomerUnsetter() {
  const dispatch = useDispatch();
  const cookies = ['customerId', 'customerType', 'customerName'];
  return () => {
    cookies.forEach((cookie: string) => {
      setCookie(cookie, '');
    });
    dispatch(unsetCustomer());
  };
}

export function InitialCustomerSetter(): null {
  const userId: number = useSelector((state: RootState) => {
    return state.user.userId;
  });
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });
  const customer: customerState = useSelector((state: RootState) => {
    return state.customer;
  });
  const [getUser, { data: fetchedUser }] = useLazyGetUserQuery();
  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
  }, [userId, getUser]);
  const setCustomer = useCustomerSetter();
  const unsetCustomer = useCustomerUnsetter();
  const setCompany = (company: any) => {
    setCustomer({
      id: company.id,
      type: customerTypes.company,
      name: company.name,
    });
  };
  const setPrivateCustomer = (customerId: number) => {
    setCustomer({
      id: customerId,
      type: customerTypes.private,
      name: `${user.firstName} ${user.lastName}`,
    });
  };
  const userData = fetchedUser?.data;
  const companiesCount = userData?.company_customers?.length ?? 0;
  const privateCount = userData?.private_customer ? 1 : 0;
  const total = companiesCount + privateCount;
  if (customer?.newlyCreated) {
    return null;
  }
  if (!userData) {
    return null;
  }
  if (!total && customer.id) {
    unsetCustomer();
  }
  if (customer.id) {
    /* TODO: fix this
    if (typeof customer.type !== CompanyCustomer) {
      unsetCustomer();
    } */
    if (
      customer.type === customerTypes.private &&
      userData?.private_customer?.id !== customer.id
    ) {
      unsetCustomer();
    }
    if (customer.type === customerTypes.company) {
      let companyFound = false;
      userData.company_customers.forEach((company: any) => {
        if (company.id === customer.id) {
          companyFound = true;
        }
      });
      if (!companyFound) {
        unsetCustomer();
      }
    }
  }
  if (customer.id) {
    return null;
  }
  if (privateCount) {
    setPrivateCustomer(userData.private_customer.id);
    return null;
  }
  if (companiesCount) {
    setCompany(userData.company_customers[0]);
    return null;
  }
  return null;
}
